export const individualStoreProfileConstants = {
  FETCH_GENERAL_DATA: "FETCH_GENERAL_DATA",
  RESET_STORE_PROFILE: "RESET_STORE_PROFILE",
  BRAND_ID: "BRAND_ID",
  FR_ROUTE: "FR_ROUTE",
  LOCATION_ID: "LOCATION_ID",
};
